import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('textBlocksModule', ['isTextBlocksReady', 'getTextBlocks']),
  },
  methods: {
    getTitleBlock(page, group, type) {
      if (this.isTextBlocksReady && this.getTextBlocks(page, group)[0]?.type === 'title') {
        return this.getTextBlocks(page, group)[0]?.content[type] || '';
      }

      return '';
    },
    getListBlock(page, group) {
      if (this.isTextBlocksReady &&
        (this.getTextBlocks(page, group)[0]?.type === 'list'
          || this.getTextBlocks(page, group)[0]?.type === 'list_key_values'
          || this.getTextBlocks(page, group)[0]?.type === 'list_links'
        )
      ) {
        return this.getTextBlocks(page, group)[0]?.content?.items || [];
      }

      return [];
    },
    getKeyValueListBlockValue(page, group, key) {
      if (this.isTextBlocksReady && this.getTextBlocks(page, group)[0]?.type === 'list_key_values') {
        const item = this.getTextBlocks(page, group)[0]?.content?.items?.find((item) => item.key === key);
        return item?.value || '';
      }

      return '';
    },
  },
};
